import { store } from 'store/reducers'
import { cloneDeep } from 'lodash'
import { MFilters } from 'types/filterTypes'

export const getFiltersForSearch = (savedOptions: MFilters.FilterTypes[MFilters.FilterKey] | Record<string, never>): { [key: string]: string[] } => {
  const {
    resources: { scheduleTypesById }
  } = store.getState() as MStore.RootState

  const options = cloneDeep(savedOptions) || {}

  // Get the leaveType id from the id that was given to each of them for display (line.402 in getFilterInfo))
  const typeMap = {
    10: 1,
    20: 2,
    30: 3
  }
  return Object.keys(options)
    .filter(key => options[key]?.length > 0)
    .reduce((obj, key) => {
      switch (key) {
        case 'clients':
        case 'resources':
        case 'customTags':
        case 'locations': {
          obj['shiftTags'] = obj['shiftTags'] ? [...obj['shiftTags'], ...options[key]] : options[key]
          break
        }
        case 'lateReason':
        case 'earlyoutReason':
        case 'leaveReason': {
          obj['reasonId'] = obj['reasonId'] ? [...obj['reasonId'], ...options[key]] : options[key]
          break
        }
        case 'notPositions': {
          obj['positionsNot'] = obj['positionsNot'] ? [...obj['positionsNot'], ...options[key]] : options[key]
          break
        }
        case 'notAttributes': {
          obj['attributesNot'] = obj['positionsNot'] ? [...obj['positionsNot'], ...options[key]] : options[key]
          obj['attributesNot'] = obj['attributesNot'].map(string => string.replace('not-', ''))
          break
        }
        case 'tagTypes': {
          obj['type'] = obj['type'] ? [...obj['type'], ...options[key]] : options[key]
          break
        }
        case 'scheduleTypes': {
          obj['scheduleTypes'] = options[key].map(scheduleTypeId => {
            const type = scheduleTypesById[scheduleTypeId]
            return type.searchRange ? `${type.startRangeStartTime}-${type.startRangeEndTime}` : `${type.startTime}@${type.endTime}`
          })
          break
        }
        case 'permissions': {
          obj['groups'] = obj['groups'] ? [...obj['groups'], ...options[key]] : options[key]
          break
        }
        case 'availabilityRequestStatus': {
          obj['approvalStatus'] = obj['approvalStatus'] ? [...obj['approvalStatus'], ...options[key]] : options[key]
          break
        }
        case 'leaveType': {
          obj['requestTypeId'] = options[key].map(type => typeMap[type])
          break
        }
        case 'vacationType': {
          obj['vacationTypeId'] = obj['vacationTypeId'] ? [...obj['vacationTypeId'], ...options[key]] : options[key]
          break
        }
        case 'shiftOptions': {
          options['shiftOptions'].forEach(option => (obj[option] = true))
          break
        }
        case 'timeOffOnlyCheck': {
          obj['vacationType'] = obj['vacationType'] ? [...obj['vacationType'], ...options[key]] : options[key]
          obj['vacationType'] = obj['vacationType'].map(string => string.replace('only-', ''))
          break
        }
        case 'timeOfDontCheck': {
          obj['vacationTypeNot'] = obj['vacationTypeNot'] ? [...obj['vacationTypeNot'], ...options[key]] : options[key]
          obj['vacationTypeNot'] = obj['vacationTypeNot'].map(string => string.replace('not-', ''))
          break
        }
        case 'contactUserStatuses': {
          obj['flags'] = obj['flags'] ? [...obj['flags'], ...options[key]] : options[key]
          break
        }
        case 'others': {
          options['others'].forEach(option => {
            switch (option) {
              case 'absence':
              case 'late':
              case 'earlyOut':
              case 'vacation':
              case 'all': {
                obj['requests'] = obj['requests'] ? [...obj['requests'], option] : [option]
                break
              }
              case 'eventOverlapping':
              case 'unavailableAllDay':
              case 'vacationOverlapping':
              case 'vacationDuringWeek':
              case 'partialTimeOffOnly': {
                obj['flag'] = obj['flag'] ? [...obj['flag'], option] : [option]
                break
              }
              case 'showAllPositions':
              case 'noEmail':
              case 'noPhoneNumbers':
              case 'archived':
              case 'notAllowedToPunch':
              case 'errorTriggered':
              case 'isEligible':
              case 'actionRequired':
              case 'currentlyCalling': {
                obj[option] = [option]
                break
              }

              case 'showAllScheduledProjects':
              case 'noPunchCard':
              case 'noProject':
              case 'showUnconfirmedByUser':
              case 'unpublished':
              case 'finalized':
              case 'showCancelledOnly':
              case 'showReplacedShifts':
              case 'requestedChanges':
              case 'notOnboarded':
              case 'neverConnected': {
                obj[option] = true
                break
              }
              case 'absenceThresholdReached':
              case 'integrationError': {
                obj[option] = ['true']
                break
              }
              case '-finalized': {
                obj['finalized'] = false
                break
              }
              case 'hasComments':
              case 'hasTransfers':
              case 'hasIssues': {
                obj['flags'] = obj['flags'] ? [...obj['flags'], option] : [option]
                break
              }
              case 'cannotBeSelfAssigned':
              case 'nonAssignable':
              case 'selfAssign': {
                obj[option] = [true]
                break
              }
              case 'unassigned':
              case '000000000000000000000000':
              case 'Merinio':
              case 'aaaaaaaaaaaaaaaaaaaaaaaa': {
                obj['users'] ? obj['users'].push(option) : (obj['users'] = [option])
                break
              }
              case 'attributeLevel':
              case 'attributes':
              case 'authentication':
              case 'availability':
              case 'bulletin':
              case 'contactListConfigss':
              case 'contactLists':
              case 'contactTemplates':
              case 'departmentModification':
              case 'departments':
              case 'emails':
              case 'finalize':
              case 'generateSchedule':
              case 'groupsPermission':
              case 'hiringData':
              case 'leave':
              case 'pay':
              case 'permissions':
              case 'projects':
              case 'punch':
              case 'punchRules':
              case 'requestsFields':
              case 'resolve':
              case 'schedule':
              case 'scheduleConfirmation':
              case 'scheduleTemplate':
              case 'scheduleTypes':
              case 'settings':
              case 'shift-cancellation-email':
              case 'shift-confirmation-email':
              case 'shift-confirmation-phone':
              case 'structure':
              case 'structureAttributes':
              case 'tags':
              case 'teams':
              case 'twilio':
              case 'user':
              case 'userAttributes':
              case 'userDepartments':
              case 'userEmails':
              case 'userFilters':
              case 'userHiringData':
              case 'userPermissions':
              case 'userPhoneNumbers':
              case 'userPicture':
              case 'userPronouns':
              case 'userPositions':
              case 'userProcedures':
              case 'regionalTags':
              case 'clients':
              case 'userSorts':
              case 'userTeams':
              case 'users': {
                obj['modules'] ? obj['modules'].push(option) : (obj['modules'] = [option])
                break
              }
              case 'vacationModule': {
                obj['modules'] ? obj['modules'].push('vacation') : (obj['modules'] = ['vacation'])
                break
              }

              default: {
                break
              }
            }
          })
          break
        }
        case 'users': {
          obj['users'] ? (obj['users'] = [...obj['users'], ...options[key]]) : (obj['users'] = options[key])
          break
        }
        case 'lockedProject': {
          obj['lockedProject'] = options['lockedProject'].map(string => string.replace('locked-', ''))
          break
        }
        case 'preferredProject': {
          obj['preferredProject'] = options['preferredProject'].map(string => string.replace('preferred-', ''))
          break
        }
        case 'blockedProject': {
          obj['blockedProject'] = options['blockedProject'].map(string => string.replace('blocked-', ''))
          break
        }
        case 'reportsTo': {
          obj['reportsTo'] = options['reportsTo'].map(string => string.replace('reportsTo-', ''))
          break
        }
        case 'eligibleForPosition': {
          obj['eligibleForPosition'] = options['eligibleForPosition'].map(string => string.replace('eligible-', ''))
          break
        }
        case 'positionSeniorities': {
          obj['positionSeniorities'] = options['positionSeniorities'].map(string => string.replace('seniority-', ''))
          break
        }
        default: {
          obj[key] = options[key]
          break
        }
      }
      return obj
    }, {})
}
